import { useState } from "react";

const WHATSAPP_NUMBER = "14078182478";
const WHATSAPP_MESSAGE = "Olá! Vim pelo site da ZB Advisor e gostaria de saber mais sobre abertura de empresa nos EUA.";

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);

  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 cursor-pointer group"
      aria-label="Falar no WhatsApp"
    >
      {/* Tooltip */}
      <div
        className={`bg-white text-[#0f2044] text-sm font-semibold px-4 py-2 rounded-full border border-gray-100 whitespace-nowrap transition-all duration-300 ${
          hovered ? "opacity-100 translate-x-0" : "opacity-0 translate-x-2 pointer-events-none"
        }`}
      >
        Falar com especialista
      </div>

      {/* Button */}
      <div className="relative w-14 h-14 flex items-center justify-center">
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full bg-[#25d366] animate-ping opacity-30" />
        <div className="relative w-14 h-14 bg-[#25d366] hover:bg-[#1ebe5d] rounded-full flex items-center justify-center transition-colors">
          <i className="ri-whatsapp-line text-white text-2xl" />
        </div>
      </div>
    </a>
  );
}
